import { normalizarDocumento } from "./documento.js";
import {
  decodificarPayloadJwtSafe,
  getNivelAcesso,
  obterDocumentoUsuarioLogado,
  obterUsuarioIdLogado,
  obterIdentidadeSessao as obterIdentidadeSessaoAuth,
} from "../../../js/auth.js";

/**
 * Sessão, identidade do usuário e camada fina de cache em sessionStorage.
 *
 * Este módulo é a única fonte de verdade para identificar o usuário
 * logado dentro desta página, replicando o padrão do CadastroEmpresa.
 */

export function decodificarPayloadJwt(token) {
  return decodificarPayloadJwtSafe(token);
}

export function obterNivelAcessoPagina() {
  return getNivelAcesso();
}

export function obterDocumentoUsuarioLogadoPagina() {
  return obterDocumentoUsuarioLogado();
}

export function obterUsuarioIdLogadoPagina() {
  return obterUsuarioIdLogado();
}

export function obterIdentidadeSessao() {
  return obterIdentidadeSessaoAuth();
}

/* ============================================================
   Cache em sessionStorage com validação por contexto
============================================================ */

export function lerCacheJSON(chave, padrao = null) {
  if (typeof window === "undefined") return padrao;
  try {
    const bruto = window.sessionStorage.getItem(chave);
    if (!bruto) return padrao;
    return JSON.parse(bruto);
  } catch {
    return padrao;
  }
}

export function salvarCacheJSON(chave, valor) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(chave, JSON.stringify(valor));
  } catch {
    /* cache opcional: falhas não devem quebrar o fluxo */
  }
}

export function removerCacheJSON(chave) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(chave);
  } catch {
    /* sem impacto no fluxo */
  }
}

export function contextosIguais(a, b) {
  return (
    String(a?.nivel || "") === String(b?.nivel || "") &&
    String(a?.usuarioId || "") === String(b?.usuarioId || "") &&
    normalizarDocumento(a?.documento) === normalizarDocumento(b?.documento)
  );
}

/**
 * Lê um cache apenas se o contexto atual coincidir com o gravado.
 * Retorna null se a sessão mudou ou se o cache está ausente.
 */
export function carregarCacheComContexto(chave, contextoAtual) {
  const cache = lerCacheJSON(chave, null);
  if (!cache || !contextosIguais(cache.contexto, contextoAtual)) return null;
  return cache;
}

export function salvarCacheComContexto(chave, contextoAtual, dados) {
  salvarCacheJSON(chave, {
    contexto: contextoAtual,
    ...dados,
    atualizadoEm: Date.now(),
  });
}

/**
 * Invalida (remove) um cache específico. Usado logo após criar/editar
 * um cadastro em outras páginas, para garantir que a próxima leitura
 * da tela de Acompanhamento vá direto pra API.
 */
export function invalidarCache(chave) {
  removerCacheJSON(chave);
}

/**
 * Chave da lista de acompanhamentos em sessionStorage.
 *
 * Centralizada aqui para que outras páginas (ex.: TcaEmpregador) possam
 * invalidar o cache da tela de Acompanhamento após salvar um cadastro.
 */
export const CACHE_KEY_ACOMPANHAMENTO_LISTA = "acompanhamento_lista_cache_v2";

/**
 * Helper que invalida especificamente o cache da lista de
 * acompanhamentos. Idempotente — pode ser chamado em qualquer ponto.
 */
export function invalidarCacheListaAcompanhamento() {
  invalidarCache(CACHE_KEY_ACOMPANHAMENTO_LISTA);
}
